(() => {
    const legacyOffsetTop = 200;

    // The independent Specs section can be removed or disabled in the editor.
    const syncSpecsLinks = () => {

        document.querySelectorAll("[data-product-tabs-anchor]").forEach((link) => {
            link.hidden = !document.getElementById(link.hash.slice(1));
        });
    };
    syncSpecsLinks();
    if (!window.productSpecsLinksInitialised) {
        document.addEventListener("shopify:section:load", syncSpecsLinks);
        document.addEventListener("shopify:section:unload", () => setTimeout(syncSpecsLinks, 0));
        window.productSpecsLinksInitialised = true;
    }

    const getHeaderHeight = () => {
        const stickyHeader = document.querySelector("sticky-header");
        return stickyHeader ? Math.max(0, stickyHeader.offsetHeight + (parseFloat(stickyHeader.closest(".shopify-section")?.style.top) || 0)) : 0;
    };

    const smoothScrollTo = (target, tabs) => {
        const anchorNav =
            tabs?.querySelector(".product-tabs__anchor-nav") ||
            Array.from(
                document.querySelectorAll("[data-product-tabs-nav]")
            ).find(
                (nav) => nav.dataset.productTabsNav === tabs?.dataset.sectionId
            );
        const offset = anchorNav
            ? getHeaderHeight() + anchorNav.offsetHeight + 16
            : legacyOffsetTop;

        window.scroll({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: "smooth",
        });
    };

    const initialiseAnchorTabs = (tabs) => {
        const anchorNav = tabs.querySelector(".product-tabs__anchor-nav");
        const links = Array.from(
            tabs.querySelectorAll("[data-product-tabs-anchor]")
        );
        const sections = Array.from(
            links,
            (link) => document.getElementById(link.hash.slice(1))
        ).filter(Boolean);

        if (!anchorNav || !links.length || !sections.length) return;

        const updateStickyOffset = () => {
            const offset = `${getHeaderHeight()}px`;
            tabs.style.setProperty("--product-tabs-sticky-top", offset);
            anchorNav.style.setProperty("--product-tabs-sticky-top", offset);
        };

        const setActiveLink = (sectionId) => {
            links.forEach((link) => {
                const isActive = link.hash === `#${sectionId}`;
                link.classList.toggle("is-active", isActive);
                if (isActive) {
                    link.setAttribute("aria-current", "true");
                } else {
                    link.removeAttribute("aria-current");
                }
            });
        };

        let ticking = false;
        const updateActiveLink = () => {
            if (ticking) return;
            ticking = true;

            requestAnimationFrame(() => {
                updateStickyOffset();
                const activationLine =
                    getHeaderHeight() + anchorNav.offsetHeight + 24;
                let activeSection = sections[0];

                sections.forEach((section) => {
                    if (section.getBoundingClientRect().top <= activationLine) {
                        activeSection = section;
                    }
                });

                setActiveLink(activeSection.id);
                ticking = false;
            });
        };

        links.forEach((link) => {
            link.addEventListener("click", (event) => {
                const target = document.getElementById(
                    link.getAttribute("href").slice(1)
                );
                if (!target) return;

                event.preventDefault();
                setActiveLink(target.id);
                smoothScrollTo(target, tabs);
                window.history.replaceState(null, "", link.hash);
            });
        });

        updateStickyOffset();
        updateActiveLink();
        document.addEventListener("bambu:sticky-offset-change", updateStickyOffset);
        window.addEventListener("resize", updateStickyOffset);
        window.addEventListener("scroll", updateActiveLink, { passive: true });

        const overviewTarget = document.getElementById(
            "product-overview-content"
        );
        if (
            overviewTarget &&
            links.some((link) => link.hash === "#product-overview-content")
        ) {
            const overviewSection = overviewTarget.closest(".shopify-section");
            anchorNav.dataset.productTabsNav = tabs.dataset.sectionId;
            anchorNav.classList.add("product-tabs__anchor-nav--dark");
            (overviewSection || overviewTarget).before(anchorNav);
        }
    };

    const initialiseLegacyTabs = (tabs) => {
        tabs.addEventListener("change", (event) => {
            const radio = event.target;

            if (radio.id?.indexOf("tab-") !== 0) return;

            const content = document.getElementById(
                radio.id.replace("tab-", "tab-content-")
            );
            if (!content) return;

            setTimeout(() => {
                const rect = content.getBoundingClientRect();
                if (rect.y < legacyOffsetTop) smoothScrollTo(content, tabs);
            }, 100);

            content.querySelectorAll("squama-item").forEach((squamaItem) => {
                squamaItem.style.height =
                    squamaItem.firstElementChild.clientHeight + "px";
            });
        });
    };

    const tabsContainers = Array.from(document.querySelectorAll(".product-tabs"));
    tabsContainers.forEach((tabs) => {
        if (tabs.dataset.tabsInitialised === "true") return;
        tabs.dataset.tabsInitialised = "true";

        if (tabs.classList.contains("product-tabs--anchors")) {
            initialiseAnchorTabs(tabs);
        } else {
            initialiseLegacyTabs(tabs);
        }
    });

    // Scroll to tabbed reviews
    const reviewApps = ["judgeme_product_reviews"];

    reviewApps.forEach((app) => {
        document.querySelectorAll('[href="#' + app + '"]').forEach((el) => {
            if (el.hash.replace("#", "") === "judgeme_product_reviews")
                el = el.firstElementChild;

            el.addEventListener("click", (event) => {
                const reviews = document.querySelectorAll("#" + app);
                if (!reviews.length) return;

                event.preventDefault();
                const content =
                    reviews[0].closest("[data-product-tabs-section]") ||
                    reviews[0].parentElement;
                const tabs = content.closest(".product-tabs");
                smoothScrollTo(content, tabs);

                const radio =
                    content &&
                    document.getElementById(
                        content.id.replace("tab-content-", "tab-")
                    );
                radio && (radio.checked = true);
            });
        });
    });
})();
